// src/pages/LandingPage/HowItWorks.jsx
import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  VStack,
  Icon,
  Circle,
} from '@chakra-ui/react';
import { FiUploadCloud, FiSliders, FiDownload } from 'react-icons/fi';

const Step = ({ number, title, description, icon, isLastStep = false }) => {
  return (
    <VStack
      position="relative"
      align="center"
      spacing={4}
      mb={isLastStep ? 0 : 16}
    >
      {/* Número na bolinha com degradê */}
      <Circle
        size="60px"
        bgGradient="linear(to-r, brand.primary, brand.secondary)"
        color="white"
        fontWeight="bold"
        fontSize="xl"
        zIndex={1}
      >
        {number}
      </Circle>

      {/* Traço de ligação vertical (oculto no último) */}
      {!isLastStep && (
        <Box
          position="absolute"
          top="60px"
          width="2px"          
          bgGradient="linear(to-b, brand.primary, brand.secondary)"
          zIndex={0}
        />
      )}

      {/* Cartão do passo */}
      <Box
        bg="white"
        rounded="lg"
        boxShadow="md"
        p={6}
        w="100%"
        maxW="320px"
        textAlign="center"
      >
        {/* Ícone centrado */}
        <Circle
          size="100px"
          bg="gray.50"
          mx="auto"
          mb={4}
          boxShadow="sm"
        >
          <Icon
            as={icon}
            boxSize={10}
            color="brand.primary"
          />
        </Circle>

        <Heading as="h3" size="md" color="brand.primary" mb={2}>
          {title}
        </Heading>
        <Text color="gray.600">{description}</Text>
      </Box>
    </VStack>
  );
};

const HowItWorks = () => (
  <Box bg="gray.50" py={20} id="como-funciona">
    <Container maxW="1200px">
      <Heading
        as="h2"
        fontSize={{ base: '3xl', md: '4xl' }}
        textAlign="center"
        mb={16}
        color="brand.primary"
      >
        Como funciona
      </Heading>

      <Stack
        direction={{ base: 'column', md: 'row' }}
        spacing={{ base: 8, md: 10 }}
        align="flex-start"
        justify="center"
        maxW="1000px"
        mx="auto"
      >
        <Step
          number={1}
          title="Faça upload"
          description="Selecione suas fotos favoritas para transformar em desenhos para colorir."
          icon={FiUploadCloud}
        />
        <Step
          number={2}
          title="Escolha o estilo"
          description="Defina o traço ou nível de detalhes que mais combina com você."
          icon={FiSliders}
        />
        <Step
          number={3}
          title="Baixe e imprima"
          description="Receba seu arquivo em alta resolução, pronto para imprimir."
          icon={FiDownload}
          isLastStep
        />
      </Stack>
    </Container>
  </Box>
);

export default HowItWorks;
